var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6624 7.10983C15.9977 7.10983 17.0809 6.0274 17.0809 4.69212C17.0809 3.35684 15.9977 2.27441 14.6624 2.27441",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7742 9.7373C16.173 9.7648 16.5694 9.82133 16.9598 9.90918C17.5021 10.0154 18.1545 10.2377 18.3867 10.7242C18.5349 11.0359 18.5349 11.3988 18.3867 11.7112C18.1553 12.1978 17.5021 12.4193 16.9598 12.5308",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24165 7.10983C3.90638 7.10983 2.82318 6.0274 2.82318 4.69212C2.82318 3.35684 3.90638 2.27441 5.24165 2.27441",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12983 9.7373C3.73108 9.7648 3.33462 9.82133 2.94427 9.90918C2.40191 10.0154 1.74955 10.2377 1.51809 10.7242C1.36913 11.0359 1.36913 11.3988 1.51809 11.7112C1.74879 12.1978 2.40191 12.4193 2.94427 12.5308",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.94813 10.2578C12.6538 10.2578 14.9654 10.6673 14.9654 12.3058C14.9654 13.9436 12.6691 14.3683 9.94813 14.3683C7.24167 14.3683 4.93091 13.9589 4.93091 12.3203C4.93091 10.6818 7.22716 10.2578 9.94813 10.2578Z",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.94815 7.92068C8.1637 7.92068 6.73294 6.48992 6.73294 4.70471C6.73294 2.92027 8.1637 1.4895 9.94815 1.4895C11.7326 1.4895 13.1634 2.92027 13.1634 4.70471C13.1634 6.48992 11.7326 7.92068 9.94815 7.92068Z",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminUsers);
export default __webpack_public_path__ + "static/media/admin-users.9c8fb9aab2f2c3f6cd1e295b12e81fec.svg";
export { ForwardRef as ReactComponent };